import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { first } from 'rxjs/operators';
import { Location } from '@angular/common';

import { Affiliate, User } from '../../../_models';
import { AffiliateService, AuthenticationService, NotificationService, UserService } from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-affiliate-detail',
  templateUrl: './affiliate-detail.component.html'
})
export class AffiliateDetailComponent implements OnInit {
  affiliate: Affiliate;
  loaded = false;
  loading = true;
  processing = false;
  clientList: any = [];

  constructor(private route: ActivatedRoute,
    private router: Router,
    private userSvc: UserService,
    private affiliateSvc: AffiliateService,
    private notification: NotificationService,
    private modalService: NgbModal,
    private _location: Location) {

  }

  ngOnInit(): void {
    let id = this.route.snapshot.paramMap.get('id');
    this.affiliateSvc.getAffiliate(id).subscribe(data => {
      this.affiliate = data;
      this.loaded = true;
      this.loading = false;
    });
    this.loadClients();
  }

  save() {
    this.processing = true;
    if (confirm("Are you sure to update this affiliate?")) {
      this.affiliateSvc.updateAffiliate(this.affiliate).subscribe(data => {
        if (data !== null) {
          if (data.status == 1) {
            this.notification.showSuccess("Affiliate updated successfully!", "Update Affiliate");
            this.modalService.dismissAll();
          } else {
            this.notification.showError(data.msg, "Fail update");
          }
        } else {
          this.notification.showError("Failed to update affiliate, please try again later.", "Fail update");
        }
      })
      this.processing = false;
    } else {
      this.processing = false;
    }
  }

  back() {
    this._location.back();
  }

  private loadClients() {
    this.userSvc.getAllClients().pipe(first()).subscribe(data => {
      this.clientList = data.data;
    });
  }

}
